import { Component, EventEmitter } from '@angular/core'
import * as THREE from 'three';
import { Promise } from 'bluebird';
import {
  HttpEventType,
  HttpResponse
} from '@angular/common/http';
import { SitesService } from '../../../services/sites.service';
import { ProductsService } from '../../../services/products.service';
import { LidarReaderService } from '../../../services/lidar-reader.service';
import { UploadService } from '../../../services/upload.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  UploadOutput,
  UploadInput,
  UploadFile,
  humanizeBytes,
  UploaderOptions
} from 'ngx-uploader';

@Component({
  selector: 'existing-site-editor',
  templateUrl: './existing-site-editor.component.html',
  styleUrls: ['./existing-site-editor.component.css']
})

export class ExistingSiteEditorComponent {
  id;
  sub;
  site;
  scene;
  lidarStats;
  lasFile;
  particleSystemBatcher;
  showRenderer: boolean = false;
  uploading: boolean = false;
  percentComplete: number = 0;
  fileName: string = '';
  options: UploaderOptions;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  loading: boolean = true;

  constructor(
    private sitesService: SitesService,
    //private productsService: ProductsService,
    private router: Router,
    private uploadService: UploadService,
    //private lidarReaderService: LidarReaderService,
    private route: ActivatedRoute
  ) {}
  ngOnInit() {
    //we have the data we need
    //get the site here
    this.options = { concurrency: 1, maxUploads: 1 };
    this.files = [];
    this.scene = new THREE.Scene();
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id'];
      this.sitesService.getSite(this.id).subscribe(site => {
        this.site = site[0];
        this.loading = false;
      })
    })
  }

  startUpload(): void {
    const event: UploadInput = {
      type: 'uploadAll',
      url: '/api/product/upload',
      method: 'POST',
      data: {}
    }

    console.log('emitting', event);
    this.uploadInput.emit(event);
  }

  onUploadOutput(output: UploadOutput): void {
    console.log('asd', output);
    if (output.type === 'allAddedToQueue') {

    } else if (output.type === 'addedToQueue' && typeof output.file !== undefined) {
      const index = this.files.findIndex(f => typeof output.file !== undefined && f.id === output.file.id);
      this.files[index] = output.file;
    }

  }

  save() {
    console.log('thisset', this.site);
    this.sitesService.updateSite(this.site)
      .subscribe(result => {
        console.log(result);
      })
    ;
  }
    // At the drag drop area
  // (drop)="onDropFile($event)"
  onDropFile(event: DragEvent) {
    event.preventDefault();
    this.uploadFile(event.dataTransfer.files);
  }

  // At the drag drop area
  // (dragover)="onDragOverFile($event)"
  onDragOverFile(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  // At the file input element
  // (change)="selectFile($event)"
  selectFile(event) {
    this.uploadFile(event.target.files);
  }

  uploadFile(files: FileList) {
    this.uploading = true;
    if (files.length == 0) {
      console.log("No file selected!");
      return
    }
    let file: File = files[0];
    this.lasFile = file;

    this.uploadService.uploadFile(files, this.id)
      .subscribe(
        event => {
          this.fileName = files[0].name;
          if (event.type == HttpEventType.UploadProgress) {
            //use this to update the loading bar
            const percentDone = Math.round(100 * event.loaded / event.total);
            this.percentComplete = percentDone;
          }
          else if (event instanceof HttpResponse) {
            const newProductId = event.body.id;
            //redirect here to the site
            this.router.navigate([`products/${newProductId}`]);
            //this.lidarReaderService.readLidarFile(file);
          }
        },
        (err) => {
          console.log("Upload Error:", err);
        }, () => {
          console.log("Upload done");
        }
      )
    ;
    //*/
  }///
}



function getBatcherStats(batcher) {
  let batcherHasColor, batcherHasIntensity, batcherInSmallRange = false;

  batcherHasColor = batcherHasColor || 
    (batcher.cx.r - batcher.cn.r) > 0.0 || 
    (batcher.cx.g - batcher.cn.g) > 0.0 || 
    (batcher.cx.b - batcher.cn.b) > 0.0;

  batcherHasIntensity = batcherHasIntensity || 
    (batcher.in_x - batcher.in_y) > 0.0;

  batcherInSmallRange = batcherInSmallRange || 
    (batcher.mn.x > -180.0 && batcher.mx.x < 180.0) && 
    (batcher.mn.y > -180.0 && batcher.mx.y < 180.0);


  return {
    batcherHasColor,
    batcherHasIntensity,
    batcherInSmallRange
  }
}